import { render, staticRenderFns } from "./FormDrawer.vue?vue&type=template&id=cb52661e&scoped=true"
import script from "./FormDrawer.vue?vue&type=script&lang=js"
export * from "./FormDrawer.vue?vue&type=script&lang=js"
import style0 from "./FormDrawer.vue?vue&type=style&index=0&id=cb52661e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb52661e",
  null
  
)

export default component.exports